<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('add_state') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="country" class="required">Country</label>
                        <app-input 
                            :placeholder = "$t('select_country_phd')" 
                            type = "advance-search-select"
                            fetch-url = "/countries/serverside/selectable-name"
                            listValueField = "name"
                            v-model = "country" 
                            :loaded-per-time = "5" 
                            :required = "true"  
                        />
                        <br>
                        <label for="code">State code</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="code"
                            placeholder="State code"
                        />
                        <br>
                        <label for="name" class="required">State name</label>
                        <app-input
                            type="text"
                            class="form-control"
                            v-model="state"
                            placeholder="State name"
                        />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "AddState",
    data() {
        return {
            country: "",
            code : "",
            state : ""
        };
    },
    methods: {
        submit() {
            this.$emit("save", this.country, this.code, this.state);
            this.country = "";
        },
    },
};
</script>
  